import { Utils } from "@/plugins/utils"
import router from "@/router"

const baseUrl = "/Financial/FinancialLiquidation"

export default {
	namespaced: true,
	state: {
		lxq: {},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getLxq: state => state.lxq,
		getLxqid(state) {
			return state.lxq.lxqid
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage: state => state.itemsPerPage,
		getLoading: state => state.loading,
		getHasNext: state => state.hasNext,
	},
	mutations: {
		set(state, lxq) {
			state.lxq = lxq
			if (lxq) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lxq = null
		},
		setParamsDataTable(state, payload) {
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLxq(state, lxq) {
			state.lxq = lxq
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
		setInsert: (state, insert) => (state.insert = insert),
		setFormError: (state, error) => (state.form.error = error),
	},
	actions: {
		setSearch: ({ commit }, search) => commit("setSearch", search),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		setLxq: ({ commit }, dc4) => commit("setDc4", dc4),
		setUpdate: ({ commit }, update) => commit("setUpdate", update),
		setInsert: ({ commit }, insert) => commit("setInsert", insert),
		setFormError: ({ commit }, error) => commit("setFormError", error),
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, dispatch, getters }) {
			commit("setLoading", true)
			let { search, limit, page } = getters.getSearch
			await this._vm.$axios
				.get(`${baseUrl}/Search?search=${search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setGridParams", payload)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async find({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get("/Financial/FinancialLiquidation/Find")
				.then(response => {
					let lxq = Utils.ValidateAxiosResponse(response.data)
					commit("set", lxq)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Financial/FinancialLiquidation/Insert", getters.getLxq)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setLxq", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/FinancialLiquidation/Update", getters.getLxq)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Financial/FinancialLiquidation/Delete/${getters.getLxqid}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
